var _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5C14.9123 14.1489 13.2152 14.4883 11.5 14.5C9.78484 14.4883 8.08773 14.1489 6.5 13.5",
    stroke: "#643EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.833,
    cy: 8.66748,
    rx: 1.5,
    ry: 1.75,
    stroke: "#643EE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.16602,
    cy: 8.66748,
    rx: 1.5,
    ry: 1.75,
    stroke: "#643EE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80222 13.951C7.33725 15.016 6.77644 16.0365 6.1267 17C4.55745 16.503 3.065 15.79 1.6923 14.8815H1.69415C1.05487 10.6513 1.9907 6.33361 4.32406 2.74769C5.65811 2.16098 7.05975 1.74189 8.4969 1.5C8.60236 1.85075 8.68713 2.20991 8.77176 2.56913C9.67388 2.42237 10.5859 2.34524 11.4999 2.33842C12.4139 2.34524 13.3259 2.42237 14.228 2.56913C14.3127 2.20991 14.3974 1.85075 14.5029 1.5C15.9401 1.74189 17.3417 2.16098 18.6757 2.74769C21.0091 6.33361 21.9449 10.6513 21.3057 14.8815H21.3075C19.9348 15.79 18.4424 16.503 16.8731 17C16.2234 16.0365 15.6626 15.016 15.1976 13.951",
    stroke: "#643EE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/DiscordIcon.ecadb7a51d4af4a3917e5014cf2d0bd4.svg";
export { ForwardRef as ReactComponent };